import { loading_cart } from './constants/cart.constant';



import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CartState } from "../../Entites/cart.model";


export const Cart = createFeatureSelector<CartState>('cart');


export const CART_TOTAL_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.cart_total;
  }
);


export const CART_Has_Error = createSelector(
  Cart, cartState => {
      return cartState.error;
  }
);

export const CART_LIST_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.cart_list;
  }
);

export const LOADING_CART_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.loading_cart;
  }
);
export const CART_DISPLAY_STATUS_SELECTOR = createSelector(
  Cart, cartState => {
      return cartState.cart_display_status;
  }
);

